<template>
	<div>
		<div size="120" class="user">
			<v-img
				:width="width"
				:height="height"
				aspect-ratio="4/3"
				:src="item"
				class="white--text align-end"
			>
				<div
					class="d-flex justify-space-between"
					style="background-color: rgba(255, 255, 255, 0.5)"
				>
					<v-btn tile text @click="$refs.FileInput.click()">
						<v-icon left> mdi-upload </v-icon>
						{{ $t("Upload") }}
					</v-btn>

					<v-btn tile text @click="openCropper">
						<v-icon left> mdi-crop </v-icon>
						{{ $t("Crop") }}
					</v-btn>
				</div>

				<input
					ref="FileInput"
					type="file"
					style="display: none"
					@change="onFileSelect"
					accept="image/*"
				/>
			</v-img>
		</div>
		<v-dialog v-model="dialog" width="950">
			<v-card>
				<v-card-title>
					<span class="headline">{{ $t("Crop Image") }}</span>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-container grid-list-xl>
						<v-layout row wrap>
							<v-flex xs12 md8>
								<cropper
									class="app-cropper"
									:src="item"
									:stencil-props="{
										aspectRatio: aspectRatio,
									}"
									@change="onChange"
									ref="cropper"
									:default-position="{
										left: 0,
										top: 0,
										bottom: 0,
										right: 0,
									}"
									:default-size="defaultSize"
									default-boundaries="fill"
									priority="visibleArea"
								/>
							</v-flex>
							<v-flex xs12 md4>
								<template v-if="result && result.image">
									<h3 class="mb-2">
										{{ $t("Previewed Result") }}
									</h3>
									<preview
										:width="width / 2"
										:height="height / 2"
										:image="result.image"
										:coordinates="result.coordinates"
									/>
								</template>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn color="blue darken-1" text @click="dialog = false">
						{{ $t("Cancel") }}
					</v-btn>
					<v-btn color="blue darken-1" text @click="onCrop">
						{{ $t("Crop") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { Cropper, Preview } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
	components: {
		Cropper,
		Preview,
	},

	props: {
		value: {
			type: String,
			default: "",
		},

		aspectRatio: {
			type: Number,
			default: 4 / 3,
		},

		width: {
			type: String,
			default: "400",
		},

		height: {
			type: String,
			default: "300",
		},
	},

	data() {
		return {
			mime_type: "",
			dialog: false,
			result: {
				coordinates: null,
				image: null,
			},
		};
	},

	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},

	methods: {
		defaultSize({ imageSize, visibleArea }) {
			return {
				width: (visibleArea || imageSize).width,
				height: (visibleArea || imageSize).height,
			};
		},

		onChange({ coordinates, image }) {
			this.result = {
				coordinates,
				image,
			};
		},

		onFileSelect(e) {
			const file = e.target.files[0];
			if (typeof FileReader === "function") {
				const reader = new FileReader();
				reader.onload = (event) => {
					this.item = event.target.result;
				};
				reader.readAsDataURL(file);
			} else {
				alert("Sorry, FileReader API not supported");
			}
		},

		openCropper() {
			this.dialog = true;
			this.$refs.cropper?.refresh();
		},

		onCrop() {
			const { coordinates, canvas } = this.$refs.cropper.getResult();
			this.coordinates = coordinates;
			this.item = canvas.toDataURL();
			this.dialog = false;
		},
	},
};
</script>

<style scoped>
.app-cropper {
	height: 600px;
	width: 600px;
	background: #ddd;
}
</style>